/**
* @name: xm-file-drag
* @author: weiyong
* @date: 2023-06-08 14:10
* @description：xm-file-drag
* @update: 2023-06-08 14:10
*/
<template>
  <div class="xm-file-drag" :id="dragViewId">
    <a-upload-dragger
      :headers="headers"
      :accept="accept"
      :data="dataUpload"
      v-if="!disabled"
      v-model:file-list="userFileList"
      :beforeUpload="beforeUpload"
      name="file"
      :multiple="false"
      :action="uploadAction"
      @change="handleChange"
    >
      <div v-if="fileList&&fileList.length===0">
        <p class="ant-upload-drag-icon">
          <inbox-outlined></inbox-outlined>
        </p>
        <p class="ant-upload-text">点击或者拖动文件到虚线框内上传</p>
        <p class="ant-upload-hint">
          <slot></slot>
          <span v-if="showRemark">一次只能上传一个文件，上传成功后，会打开文件进行预览查看</span>
        </p>
      </div>
      <div v-else>
        <p class="ant-upload-drag-icon">
          <inbox-outlined></inbox-outlined>
        </p>
        <span>重新上传</span>
      </div>
    </a-upload-dragger>
    <!--    附件预览 -->
    <a-spin v-if="fileListFlag" :spinning="loadingFlag" :indicator="indicator">
      <file-show-list :fileAclInfo="fileAclInfo"
                      v-if="fileAclInfo.preview||fileAclInfo.download"
                      :fileList="fileList"
                      @flushFileList="flushFileList"
                      @loading="loadingFun"
                      @closeLoading="closeLoadingFun"
                      :businessId="businessId"></file-show-list>
    </a-spin>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "xm-file-drag",
});
</script>

<script lang="ts" setup>
import {UploadDragger as AUploadDragger} from 'ant-design-vue';
import FileShowList from "@/components/xmFileComCtl/coms/file-show-list.vue";
import {UploadProps} from "ant-design-vue";
import {InboxOutlined, ExpandOutlined} from "@ant-design/icons-vue";
import {useFileUploadHooks} from "@/components/xmFileComCtl/hooks/useFileUploadHooks";
import {useFileUploadEventHooks} from "@/components/xmFileComCtl/hooks/useFileUploadEventHooks";
import {GoingNewUtils} from "xmgoing-utils";

interface propTypes {
  fileListFlag: boolean,
  fileAclInfo: any,
  //导入组件特有参数
  importParams: any,
  //上传时额外参数
  params: any,
  //关联id
  businessId: string,
  //上传url
  userUploadAction: string,
  //上传文件类型
  accept: string,
  //是否可以上传
  disabled: boolean,
  //是否允许多传
  multiple: boolean,
  //显示备注说明
  showRemark: boolean,
}

const props = withDefaults(defineProps<propTypes>(), {
  fileListFlag: true,
  fileAclInfo: {download: true, preview: true, delete: false, upload: true},
  //导入组件特有参数
  importParams: [],
  //上传时额外参数
  params: {},
  //上传文件类型
  accept: '',
  //关联id
  businessId: '',
  //上传url
  userUploadAction: '',
  //是否允许多传
  multiple: false,
  //是否可以上传
  disabled: false,
  //显示备注说明
  showRemark: true,
});
const {businessId, userUploadAction, multiple, importParams, params} = toRefs(props);

const userFileList = ref<UploadProps['fileList']>([]);
const emits = defineEmits(['update:busId', 'update:fileUrl', 'done', 'afterLoadList', 'error', 'beforeUpload']);
const {
  dataUpload,
  uploadAction,
  headers,
} = useFileUploadHooks({params, importParams, emits, businessId, uploadAction: userUploadAction});

const {beforeUpload, handleChange} = useFileUploadEventHooks({
  uploadAction, multiple, emit: emits, userFileList,businessId, flushList: function () {
    userFileList.value = [];
  }
});

const dragViewId = GoingNewUtils.getUUChar(20);

const {
  fileList,
  flushFileList,
  indicator,
  loadingFlag,
  loadingFun,
  closeLoadingFun
} = useFileUploadHooks({emits, businessId});

defineExpose({})
</script>

<style type="text/css" lang="less">

</style>
